<style lang="stylus">
    .OrgChartImport-container
        position fixed
        top 0
        right 0
        left 0
        bottom 0
        margin auto
        width 740px
        height 80%
        max-height 691px
        min-height 500px
        background-color var(--bg-color-tertiary)
        border-radius 5px
        box-shadow var(--box-orgchartimport-container)
        z-index 21
        .OrgChartImport-header
            // width 552px
            height 40px
            border-bottom 1px solid var(--border-color-float-hv-line)
            display flex
            justify-content space-between
            align-items center
            padding 0 12px
            .header-title
                display flex
                align-items center
                img
                    width 16px
                    height 16px
                    margin-right 4px
            .header-close
                width 24px
                height 24px
                cursor pointer
                display flex
                justify-content center
                align-items center
                border-radius: 6px;
                .close-icon
                    color var(--svg-color-gray-42)
                    width 16px
                    height 16px
                &:hover
                    background var(--bg-color-dialog-close-hover)
        .OrgChartImport-content
            padding 16px 24px 24px
            .title-label
                margin-bottom 16px
            .content-one
                @media screen and (max-height: 768px)
                    max-height 350px
                    overflow-y auto

                .one-description
                    .one-description-title
                        font-size 14px
                        font-weight 700
                        color var(--text-color-orgchartimport-step-one-title)
                    .one-description-text
                        font-size 14px
                        color var(--text-color-orgchartimport-step-one-desc)
                        margin-left 15px
                        margin-top 5px
                .one-download
                    position relative
                    overflow auto
                    margin-top 24px
                    .download-btn
                        blueBtn()
                        height 28px
                        width min-content
                        padding 6px 16px
                        white-space nowrap
                        margin-right 16px
                        .download-icon
                            width 16px
                            height 16px
                            color var(--bg-color-tertiary)
                            margin-right 4px
                    .download-content
                        display flex
                        align-items center
                        .download-help
                            display flex
                            align-items center
                            .help-icon
                                width 16px
                                height 16px
                                margin-right 4px
                                svg
                                    width 16px
                                    height 16px
                                    color var(--text-color-primary)
                            .help-btn
                                color var(--themeColor)
                                &:hover
                                    color #0a7bed



                .one-import
                    position relative
                    margin-bottom 24px
                    overflow hidden
                    display flex
                    gap 16px
                    .import-text
                        flex 1
                        height 28px
                        line-height 28px
                        text-indent 10px
                        border 1px solid var(--border-color-float-hv-line)
                        border-radius 6px
                        // color var(--text-color-tertiary)
                        &::placeholder
                            color var(--text-color-tertiary)
                    .import-btn
                        width 116px
                        height 28px
                        text-align center
                        line-height 28px
                        blueBtn()
                    .import-loading
                        position absolute
                        left 365px
                        >svg
                            width 29px
                            height 29px
                            color var(--themeColor)
                .description-content
                    width 100%
                    padding 12px 16px
                    border-radius 6px
                    background var(--bg-color-library-modal-right-top)
                    position relative
                    margin-bottom 16px
                    line-height 20px
                    &::after
                        content ""
                        width 0
                        height 0
                        border-left 12px solid transparent
                        border-right 12px solid transparent
                        border-top 12px solid var(--bg-color-library-modal-right-top)
                        position absolute
                        left 100px
                        bottom -12px

                .one-link
                    display block
                    margin-top 46px
                    &:active,&:hover,&:link,&:visited
                        color #969696
                        text-decoration underline
                .ivu-table-cell
                    padding-left: 0;
                    padding-right: 0;
                .ivu-table
                    color var(--text-color-primary)
                    border-radius 6px
                    &:before
                        background: unset;
                    th
                        background #fff
                        font-weight 400
                        height 28px
                        &:nth-child(2),&:nth-child(3)
                            background var(--bg-color-library-modal-right-top)
                            border-right 1px solid var(--themeColor)
                            border-top 1px solid var(--themeColor)
                        &:nth-child(1)
                            border-right 1px solid var(--themeColor)
                        .ivu-table-cell
                            width 90%
                            margin auto

                    td
                        height 28px
                        &:nth-child(2),&:nth-child(3)
                            background-color var(--bg-color-library-modal-right-top)
                            border-right 1px solid var(--themeColor)
                        &:nth-child(1)
                            border-right 1px solid var(--themeColor)


                    tr
                        &:last-child
                            td
                                &:nth-child(2),&:nth-child(3)
                                    border-bottom 1px solid var(--themeColor)
                    table
                        // border 1px solid #EBEBEB
                        border-radius 6px



            .content-two
                position relative
                .check-tip
                    display flex
                    align-items center
                    margin-bottom 24px
                    svg
                        width 24px
                        height 24px
                        margin-right 8px
                    span
                        line-height 20px
                        flex 1
            .content-three
                position relative
                @media screen and (max-height: 768px)
                    max-height 350px
                    overflow-y auto
                .three-title
                    font-size 14px
                    font-weight 700
                    color var(--text-color-orgchartimport-step-one-title)
                    margin-bottom 27px
                .set-item
                    margin 22px 0
                    display flex
                    align-items center
                    .label
                        display block
                        width 100px
                    .text
                        width 180px
                .set-text
                    margin-bottom 32px
                    .ivu-radio-wrapper
                        &:first-child
                            width 200px
                .setOrgPage
                    margin-top 32px


            .three-table
                width 100%
                display flex
                flex-direction column
                max-height 592px
                border-radius 6px
                border 1px solid var(--border-color-float-hv-line)
                overflow hidden
                table
                    position relative
                    border-collapse separate
                    border-spacing 0
                    margin 0
                    border-width 0
                    table-layout fixed
                    width 100%
                    outline-width 0
                    max-width none
                    max-height none
                    thead
                        tr
                            // background-color var(--bg-color-orgchartimport-table-tr)
                            th
                                padding 6px 0
                                border-bottom 1px solid var(--border-color-float-hv-line)
                                border-right 1px solid var(--border-color-float-hv-line)
                                width 100%
                                text-align center
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                                &:last-child
                                    border-right unset
                    tbody
                        tr
                            border-bottom 1px solid var(--border-color-float-hv-line)
                            td
                                padding 0px 8px
                                cursor pointer
                                border-right 1px solid var(--border-color-float-hv-line)
                                border-bottom 1px solid var(--border-color-float-hv-line)
                                height 28px
                                line-height 28px
                                >div
                                    width 100%
                                    height 100%
                                    text-align center
                                    overflow hidden
                                    text-overflow ellipsis
                                    white-space nowrap
                                    border 1px solid transparent
                                &.effTd
                                    background rgba(255, 0, 0, 0.08);
                                &.editingEffTd
                                    padding 0
                                    .ivu-input
                                        border-radius 0
                                        height calc(100% - 1px)
                                        color var(--text-color-primary) !important
                                    >div
                                        border 0
                                .orientation-icon
                                    width 16px
                                    height 16px

                            &:last-child
                                td
                                    border-bottom unset

                                &:hover
                                    background-color var(--bg-color-orgchartimport-tr-hover)
                                .tbody-checkbox
                                    position relative
                                    margin 0 auto
                                    top 3px
                                    width 16px
                                    height 16px
                                    border 1px solid var(--border-color-ivu-checkbox-inner)
                                    border-radius 3px
                                    background #fff
                                    cursor pointer
                                .tbody-checkbox.checked
                                    background #fff
                                    border-color var(--themeColor)
                                .tbody-checkbox.checked:after
                                    content ''
                                    position absolute
                                    top 3px
                                    left 3px
                                    background transparent
                                    border 2px solid var(--themeColor)
                                    border-top none
                                    border-right none
                                    height 6px
                                    width 9px
                                    transform rotate(-45deg)
                                .tbody-name
                                    width 102px
                                    overflow hidden
                                    text-overflow ellipsis
                                    white-space nowrap
                                    font-size 14px
                                    color var(--svg-color-gray-42)
                                .tbody-selectbox
                                    margin 0 auto
                                    width 132px
                                    height 28px
                                    border 1px solid var(--border-color-orgchartimport-import-btn)
                                    border-radius 4px
                                    position relative
                                    cursor pointer
                                    user-select none

                                    .selectbox-title
                                        font-size 14px
                                        text-indent 10px
                                        line-height 26px

                                    .selectbox-icon
                                        svg
                                            position absolute
                                            right 10px
                                            top 6px
                                            width 14px
                                            height 16px
                                            color var(--svg-color-gray-75)
                                            pointer-events none

                                    ul
                                        position absolute
                                        width 100%
                                        box-shadow var(--box-orgchartimport-container)
                                        background-color var(--bg-color-tertiary)
                                        z-index 1
                                        li
                                            list-style none
                                            text-indent 10px
                                            padding 5px 0
                                            cursor pointer
                                            user-select none
                                            &:hover
                                                background-color var(--bg-color-font-list-item-hover)
                                .tbody-selectbox.tbody-ban
                                    cursor not-allowed
                .table-header
                    width 100%
                .table-content
                    width 100%
                    flex 1
                    overflow-y auto
                    max-height 387px
                .table-content::-webkit-scrollbar
                    display none
                .last-step
                    max-height 185px
                    table
                        tbody
                            tr
                                td
                                    padding 0;
        .OrgChartImport-controlbox
            position absolute
            right 24px
            bottom 24px
            div
                padding 0 18px
                float left
                min-width 72px
                height 28px
                // border 1px solid var(--border-color-orgchartimport-footer-btn)
                border-radius 6px
                text-align center
                line-height 28px
                background-color #EBEDF1
                cursor pointer
                user-select none

                &:not(:nth-child(3))
                    margin-right 8px
                &:not(.controlbox-ban):hover
                    background-color var(--bg-color-dialog-cancel-btn-hover)
                &:nth-child(2)
                    background-color var(--themeColor)
                    color var(--color-white)
                    &:hover
                        background var(--themeHover)
            .controlbox-ban
                border-color var(--border-color-orgchartimport-footer-step-btn)
                color #c1c1c1
                cursor not-allowed
                // &:hover
                //     background-color var(--bg-color-dialog-cancel-btn-hover)
</style>

<template>
    <div class="OrgChartImport-container">
        <div class="OrgChartImport-header">
            <p class="header-title">
                <img :src="require('@/app/assets/topPanel/logo.svg')" alt="" />
                <span>{{ $t("OrgChartImport.title") }}</span>
            </p>
            <div class="header-close" @click="closeModal()">
                <iconSymbol class="close-icon" name="Del" />
            </div>
        </div>
        <div class="OrgChartImport-content">
            <div class="content-one" v-show="step == 0">
                <div class="title-label">{{ $t("OrgChartImport.chooseFileTitle") }}:</div>
                <div class="one-import">
                    <div ref="importText" class="import-text">{{ $t("OrgChartImport.importText") }}</div>
                    <div class="import-btn" @click="clickImportFile()">{{ $t("OrgChartImport.importBtn") }}</div>
                    <input id="importer" type="file" accept=".xlsx,.xls,.csv,.txt" style="display: none" @change="getFile($event)" />
                    <div class="import-loading" v-show="!loadingFileOK">
                        <iconSymbol name="import-loading" />
                    </div>
                </div>
                <div class="title-label">{{ $t("OrgChartImport.contentTitle") }}:</div>
                <div class="description-content">
                    {{ $t("OrgChartImport.descriptionContent") }}
                </div>
                <Table :columns="getPageOneColumns()" :data="getPageOneData()" :border="true" size="small"></Table>
                <div class="one-download">
                    <div class="title-label">{{ $t("OrgChartImport.downloadTitle") }}:</div>
                    <div class="download-content">
                        <a
                            class="download-btn"
                            target="_blank"
                            :href="
                                lang === 'zh'
                                    ? 'https://www.edrawsoft.com/orgchart/simpleorgchartdata-cn.zip'
                                    : 'https://www.edrawsoft.com/orgchart/simpleorgchartdata.zip'
                            "
                        >
                            <iconSymbol class="download-icon" name="downloadBtn" />
                            <span>{{ $t("OrgChartImport.downloadBtn") }}</span>
                        </a>
                        <div class="download-help">
                            <iconSymbol class="help-icon" name="helpBtn" />
                            <span>{{ $t("OrgChartImport.helpTip") }}</span>
                            <a class="help-btn" target="_blank" :href="$t('OrgChartImport.url')">{{ $t("OrgChartImport.helpBtn") }}</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="content-two" v-show="step == 1">
                <div class="title-label">
                    {{ $t("OrgChartImport.checkTitle") }}
                </div>
                <div class="check-tip">
                    <iconSymbol :name="checkTipStr === 'success' ? 'success-icon' : 'warning-icon'" />
                    <span>{{ $t(`checkTip.${checkTipStr}`) }}</span>
                </div>

                <div class="three-table">
                    <div class="table-header">
                        <table>
                            <colgroup>
                                <col style="width: 32px" />
                                <col v-for="(column, index) in checkColumns" :key="index" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th key="-1"></th>
                                    <th v-for="(column, index) in checkColumns" :key="index">{{ column.title }}</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="table-content">
                        <table>
                            <colgroup>
                                <col style="width: 32px" />
                                <col v-for="(column, index) in checkColumns" :key="index" />
                            </colgroup>
                            <tbody>
                                <tr v-for="(item, rowIndex) in checkData" :key="item.id">
                                    <td>{{ rowIndex + 1 }}</td>
                                    <td
                                        v-for="(column, columnIndex) in checkColumns"
                                        :key="columnIndex"
                                        @click="handleCellClick(rowIndex, columnIndex)"
                                        :class="{
                                            effTd: checkErrArr.includes(`${rowIndex}-${columnIndex}`),
                                            editingEffTd: !!isPageTwoTdEditing(rowIndex, columnIndex),
                                        }"
                                    >
                                        <div v-if="!isPageTwoTdEditing(rowIndex, columnIndex)">
                                            {{ item[column.key] }}
                                        </div>
                                        <div v-else>
                                            <Input
                                                size="small"
                                                :ref="`cellInput-${rowIndex}-${columnIndex}`"
                                                :key="rowIndex + '-' + columnIndex"
                                                v-model="item[column.key]"
                                                @on-blur="handleBlur(rowIndex, columnIndex)"
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="content-three" v-show="step == 2">
                <div class="title-label">
                    {{ $t("OrgChartImport.setCarTitle") }}
                </div>
                <div class="set-photo set-item">
                    <span class="label">{{ $t("setPhoto") }}:</span>
                    <Checkbox v-model="submitData['showPhoto']" @on-change="changeShowPhoto" />
                    <span class="text">{{ $t("showPhoto") }}</span>
                    <i-select v-model="submitData['orientation']" style="width: 80px" size="small" :disabled="orientationDisp">
                        <i-option v-for="item in orientationList" :value="item.value" :key="item.value">{{ $t(item.label) }}</i-option>
                    </i-select>
                </div>
                <div class="set-text set-item">
                    <span class="label" style="">{{ $t("setText") }}:</span>
                    <RadioGroup v-model="submitData['textWrap']">
                        <Radio label="wrap">
                            <span>{{ $t("setTextWrap") }}</span>
                        </Radio>
                        <Radio label="nowrap">
                            <span>{{ $t("setTextNoWrap") }}</span>
                        </Radio>
                    </RadioGroup>
                </div>
                <div class="title-label">{{ $t("setCardInfo") }}</div>
                <!-- <p class="three-title">{{ $t("OrgChartImport.table.title") }}</p> -->
                <div class="three-table">
                    <div class="table-header">
                        <table>
                            <colgroup>
                                <col style="width: 25%" />
                                <col style="width: 25%" />
                                <col style="width: 25%" />
                                <col style="width: 25%" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>{{ $t("info") }}</th>
                                    <th>{{ $t("showHidden") }}</th>
                                    <th>{{ $t("toTop") }}</th>
                                    <th>{{ $t("toBottom") }}</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div class="table-content last-step">
                        <table>
                            <colgroup>
                                <col style="width: 25%" />
                                <col style="width: 25%" />
                                <col style="width: 25%" />
                                <col style="width: 25%" />
                            </colgroup>
                            <tbody>
                                <tr v-for="(item, index) in pageThreeData" :key="item.id">
                                    <td>
                                        <div>{{ item.basename }}</div>
                                    </td>
                                    <td>
                                        <div>
                                            <Checkbox :value="item.checked" @on-change="(val) => clickTableCheck(item.id, val)" />
                                        </div>
                                    </td>
                                    <td>
                                        <div @click="changeRow('up', index)" style="display: flex; justify-content: center; align-items: center">
                                            <iconSymbol class="orientation-icon" name="toTop" />
                                        </div>
                                    </td>
                                    <td>
                                        <div @click="changeRow('down', index)" style="display: flex; justify-content: center; align-items: center">
                                            <iconSymbol class="orientation-icon" name="toBottom" />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="setOrgPage">
                    <RadioGroup v-model="forPage" vertical>
                        <Radio label="forOnePage">
                            <span>{{ $t("forOnePage") }}</span>
                        </Radio>
                        <Radio label="forMorePage">
                            <span>{{ $t("forMorePage") }}</span>
                        </Radio>
                    </RadioGroup>
                </div>
            </div>
        </div>
        <div class="OrgChartImport-controlbox">
            <div :class="{ 'controlbox-ban': step === 0 }" @click="clickBtn(0)">{{ $t("OrgChartImport.btnbox.prev") }}</div>
            <div v-if="step != 2" :class="{ 'controlbox-ban': !isFile }" @click="clickBtn(1, true)">
                {{ $t("OrgChartImport.btnbox.next") }}
            </div>
            <div v-else @click="clickBtn(2)">{{ $t("OrgChartImport.btnbox.complete") }}</div>
            <div @click="clickBtn(3)">{{ $t("OrgChartImport.btnbox.cancel") }}</div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class OrgChartImport extends Vue {
        hiddenArr: Array<string> = [];
        step: number = 0; // 步骤
        checkedFullName: boolean = false;
        clickBtnFlag: boolean = false;
        isFile: boolean = false; //是否选择文件
        importFileName: string = "";
        showList: number = -1;
        showTableListOne: number = -1;
        showTableListTwo: number = -1;
        checkTipStr: string = "success";

        getPageOneColumns() {
            const ts = this;
            const columns = [
                {
                    title: "",
                    key: "num",
                    width: 32,
                    ellipsis: true,
                },
                {
                    title: ts.$t("tableData.th.name"),
                    key: "name",
                    width: 80,
                    ellipsis: true,
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "90%",
                                    margin: "0 auto",
                                },
                                attrs: {
                                    title: params.row.name,
                                },
                            },
                            params.row.name
                        );
                    },
                },
                {
                    title: ts.$t("tableData.th.reports"),
                    key: "reportsTo",
                    width: 80,
                    ellipsis: true,
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "90%",
                                    margin: "0 auto",
                                },
                                attrs: {
                                    title: params.row.reportsTo,
                                },
                            },
                            params.row.reportsTo
                        );
                    },
                },
                {
                    title: ts.$t("tableData.th.title"),
                    key: "title",
                    width: 80,
                    ellipsis: true,
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "90%",
                                    margin: "0 auto",
                                },
                                attrs: {
                                    title: params.row.title,
                                },
                            },
                            params.row.title
                        );
                    },
                },
                {
                    title: ts.$t("tableData.th.department"),
                    key: "department",
                    width: 80,
                    ellipsis: true,
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "90%",
                                    margin: "0 auto",
                                },
                                attrs: {
                                    title: params.row.department,
                                },
                            },
                            params.row.department
                        );
                    },
                },
                {
                    title: ts.$t("tableData.th.mobile"),
                    key: "mobile",
                    width: 104,
                    ellipsis: true,
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "90%",
                                    margin: "0 auto",
                                },
                                attrs: {
                                    title: params.row.mobile,
                                },
                            },
                            params.row.mobile
                        );
                    },
                },
                {
                    title: ts.$t("tableData.th.email"),
                    key: "email",
                    width: 139,
                    ellipsis: true,
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "90%",
                                    margin: "0 auto",
                                },
                                attrs: {
                                    title: params.row.email,
                                },
                            },
                            params.row.email
                        );
                    },
                },
                {
                    title: ts.$t("tableData.th.info"),
                    key: "info",
                    ellipsis: true,
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    maxWidth: "90%",
                                    margin: "0 auto",
                                },
                                attrs: {
                                    title: params.row.info,
                                },
                            },
                            params.row.info
                        );
                    },
                },
            ];
            columns.forEach((column: any, index) => {
                column.align = "center";
            });
            return columns;
        }

        getPageOneData() {
            const ts = this;
            const data = [
                {
                    name: this.$t("tableData.td.name1"),
                    reportsTo: "",
                    title: this.$t("tableData.td.title1"),
                    department: this.$t("tableData.td.title1"),
                    mobile: "18568778754",
                    email: "jjte@233.com",
                    info: "xxx",
                },
                {
                    name: this.$t("tableData.td.name2"),
                    reportsTo: this.$t("tableData.td.name1"),
                    title: this.$t("tableData.td.title2"),
                    department: this.$t("tableData.td.department1"),
                    mobile: "18568778754",
                    email: "jjte@233.com",
                    info: "xxx",
                },
                {
                    name: this.$t("tableData.td.name3"),
                    reportsTo: this.$t("tableData.td.name2"),
                    title: this.$t("tableData.td.title3"),
                    department: this.$t("tableData.td.department1"),
                    mobile: "18568778754",
                    email: "jjte@233.com",
                    info: "xxx",
                },
                {
                    name: this.$t("tableData.td.name4"),
                    reportsTo: this.$t("tableData.td.name3"),
                    title: this.$t("tableData.td.title4"),
                    department: this.$t("tableData.td.department2"),
                    mobile: "18568778754",
                    email: "jjte@233.com",
                    info: "xxx",
                },
                {
                    name: this.$t("tableData.td.name5"),
                    reportsTo: this.$t("tableData.td.name4"),
                    title: this.$t("tableData.td.title5"),
                    department: this.$t("tableData.td.department2"),
                    mobile: "18568778754",
                    email: "jjte@233.com",
                    info: "xxx",
                },
                {},
                {},
            ];
            data.forEach((item: any, index) => {
                item.num = index + 1;
            });
            return data;
        }

        pageTwoData: Array<object> = [
            {
                id: 0,
                name: "fullName",
                showName: "none",
                list: ["aaaaaaaaaaaaa", "bbbbbbbbbbbbb", "ccccccccccccc", "ddddddddddddd", "eeeeeeeeeeeee"],
            },
            {
                id: 1,
                name: "lastName",
                showName: "none",
                list: ["aaaaaaaaaaaaa", "bbbbbbbbbbbbb", "ccccccccccccc", "ddddddddddddd", "eeeeeeeeeeeee"],
            },
            {
                id: 2,
                name: "reportTo",
                showName: "none",
                list: ["aaaaaaaaaaaaa", "bbbbbbbbbbbbb", "ccccccccccccc", "ddddddddddddd", "eeeeeeeeeeeee"],
            },
            {
                id: 3,
                name: "isAssistant",
                showName: "none",
                list: ["aaaaaaaaaaaaa", "bbbbbbbbbbbbb", "ccccccccccccc", "ddddddddddddd", "eeeeeeeeeeeee"],
            },
        ];
        pageThreeData: Array<any> = [
            {
                id: 0,
                checked: true,
                basename: "11111111111",
                name1: "false",
                name2: "String",
                list1: ["true", "false"],
                list2: ["String", "Number", "Date", "Duration", "Currency", "Boolean", "Percentage", "Scientific"],
            },
        ];
        get submitData(): object {
            return {
                relationArr: ["none", "none", "none", "none", "none", "none", "none"],
                useFullName: false,
                selectArr: [],
                showPhoto: false,
                orientation: 0,
                textWrap: "wrap",
                orderArr: [],
            };
        }
        loadingFileOK: boolean = true;
        fileDataArr: any = [];
        getFile(e) {
            this.loadingFileOK = false;
            let file = e.target.files[0];
            (this.$refs.importText as HTMLElement).innerHTML = file.name;
            let ts = this;
            let oFReader = new FileReader();

            oFReader.readAsBinaryString(file);
            oFReader.onload = (oFREvent: any) => {
                file = oFREvent.target.result;
                let arr = window["_view"]._orgUITool.orgImportTitles(file);

                ts.pageThreeData = arr.map((v, k) => {
                    let obj = {
                        id: k,
                        checked: true,
                        basename: v,
                        name1: "true",
                        name2: "String",
                        list1: ["true", "false"],
                        list2: ["String", "Number", "Date", "Duration", "Currency", "Boolean", "Percentage", "Scientific"],
                    };
                    return obj;
                });
                arr.unshift(ts.$t("none"));
                if (
                    arr.includes("Name") ||
                    (this.lang === "zh" && arr.includes(this.$t("tableData.th.name"))) ||
                    arr.includes("Employee ID") ||
                    (this.lang === "zh" && arr.includes("工号"))
                ) {
                    if (arr.includes("Employee ID") || (this.lang === "zh" && arr.includes("工号"))) {
                        ts.submitData["relationArr"][0] = this.lang === "zh" ? "工号" : "Employee ID";
                    } else {
                        ts.submitData["relationArr"][0] = this.lang === "zh" ? this.$t("tableData.th.name") : "Name";
                    }
                } else {
                    ts.submitData["relationArr"][0] = ts.$t("none");
                }
                if (arr.includes("ReportsTo") || (this.lang === "zh" && arr.includes(this.$t("tableData.th.reports")))) {
                    ts.submitData["relationArr"][1] = this.lang === "zh" ? this.$t("tableData.th.reports") : "ReportsTo";
                } else {
                    ts.submitData["relationArr"][1] = ts.$t("none");
                }
                if (arr.includes("Title") || (this.lang === "zh" && arr.includes(this.$t("tableData.th.title")))) {
                    ts.submitData["relationArr"][2] = this.lang === "zh" ? this.$t("tableData.th.title") : "Title";
                } else {
                    ts.submitData["relationArr"][2] = ts.$t("none");
                }
                if (arr.includes("Department") || (this.lang === "zh" && arr.includes(this.$t("tableData.th.department")))) {
                    ts.submitData["relationArr"][3] = this.lang === "zh" ? this.$t("tableData.th.department") : "Department";
                } else {
                    ts.submitData["relationArr"][3] = ts.$t("none");
                }
                if (arr.includes("Phone") || (this.lang === "zh" && arr.includes(this.$t("tableData.th.mobile")))) {
                    ts.submitData["relationArr"][4] = this.lang === "zh" ? this.$t("tableData.th.mobile") : "Phone";
                } else {
                    ts.submitData["relationArr"][4] = ts.$t("none");
                }
                if (arr.includes("Email") || (this.lang === "zh" && arr.includes(this.$t("tableData.th.email")))) {
                    ts.submitData["relationArr"][5] = this.lang === "zh" ? this.$t("tableData.th.email") : "Email";
                } else {
                    ts.submitData["relationArr"][5] = ts.$t("none");
                }
                if (arr.includes("IsAssistant") || arr.includes("是否助理")) {
                    ts.submitData["relationArr"][6] = this.lang === "zh" ? "是否助理" : "IsAssistant";
                } else {
                    ts.submitData["relationArr"][6] = ts.$t("none");
                }

                ts.isFile = true;
                ts.loadingFileOK = true;

                ts.$nextTick(() => {
                    let importExcelData = [];
                    window["_view"].chartImportFromExcel((oFREvent.target as any).result, importExcelData);
                    ts.fileDataArr = importExcelData;
                    ts.initCheckTable();
                });
            };
        }
        clickSelectbox(index) {
            if (this.showList != -1) {
                this.showList = -1;
                document.removeEventListener("click", this.closeBox);
                return;
            }
            this.showList = index;
            document.addEventListener("click", this.closeBox);
        }
        clickSelectList(id, data) {
            this.showList = -1;
            this.pageTwoData[id]["showName"] = data;
            this.submitData["relationArr"][id] = data;
            document.removeEventListener("click", this.closeBox);
        }
        clickTablebox(type, id) {
            if (type == 0) {
                if (this.showTableListOne != -1) {
                    this.showTableListOne = -1;
                    document.removeEventListener("click", this.closeColumn);
                    return;
                }
                this.showTableListOne = id;
                document.addEventListener("click", this.closeColumn);
            } else {
                if (this.pageThreeData[id]["name1"] == "true") {
                    return;
                }
                if (this.showTableListTwo != -1) {
                    this.showTableListTwo = -1;
                    document.removeEventListener("click", this.closeType);
                    return;
                }
                this.showTableListTwo = id;
                document.addEventListener("click", this.closeType);
            }
        }
        clickTableList(type, id, data) {
            if (type == 0) {
                this.showTableListOne = -1;
                this.pageThreeData[id]["name1"] = data;
                document.removeEventListener("click", this.closeColumn);
            } else {
                this.showTableListTwo = -1;
                this.pageThreeData[id]["name2"] = data;
                document.removeEventListener("click", this.closeType);
            }
        }
        clickImportFile() {
            document.getElementById("importer").click();
        }
        clickCheckBox() {
            this.checkedFullName = !this.checkedFullName;
            this.submitData["useFullName"] = this.checkedFullName;
        }
        clickTableCheck(id, val) {
            this.pageThreeData[id]["checked"] = val;
        }
        setThreeData() {
            return this.pageThreeData.map((v, k) => {
                return {
                    name: v["basename"],
                    checked: v["checked"],
                    selectOne: v["name1"] == "true" ? true : false,
                    selectTwo: v["name2"],
                };
            });
        }
        clickBtn(type, fromClick?: boolean) {
            if (this.clickBtnFlag) {
                return;
            }
            this.clickBtnFlag = true;
            setTimeout(() => {
                switch (
                    type // 0 上一步，1 下一步，2 完成，3 取消
                ) {
                    case 0: {
                        this.step = this.step <= 0 || this.checkTipStr == "success" ? 0 : this.step - 1;
                        break;
                    }
                    case 1: {
                        if (this.isFile) {
                            this.step = this.step + 1;
                            this.checkFileData(fromClick);
                        }

                        break;
                    }
                    case 2: {
                        this.submitData["selectArr"] = this.setThreeData();
                        window["_view"]._orgUITool.orgImportFromFile(this.submitData);
                        this.closeModal();
                        break;
                    }
                    case 3: {
                        this.closeModal();
                        break;
                    }
                }
                this.clickBtnFlag = false;
            }, 200);
        }
        closeBox(e) {
            let typelistBox = document.getElementById(`selectboxName${this.showList}`);
            if (typelistBox != e.target) {
                this.showList = -1;
            }
        }
        closeColumn(e) {
            let Box = document.getElementById(`tbodyColumnName${this.showTableListOne}`);
            if (Box != e.target) {
                this.showTableListOne = -1;
            }
        }
        closeType(e) {
            let Box = document.getElementById(`tbodyTypeName${this.showTableListTwo}`);
            if (Box != e.target) {
                this.showTableListTwo = -1;
            }
        }

        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        OKModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        keyboardEvent(e) {
            if (e.keyCode == 27) {
                // esc
                this.closeModal();
            }
        }

        editingCells: any = {};
        checkColumns = [];
        checkData = [];

        isPageTwoTdEditing(rowIndex, columnIndex) {
            const cellKey = `${rowIndex}_${columnIndex}`;
            return this.editingCells[cellKey];
        }
        handleCellClick(rowIndex, columnIndex) {
            const cellKey = `${rowIndex}_${columnIndex}`;
            this.$set(this.editingCells, cellKey, true);
            this.$nextTick(() => {
                let inputRefs = this.$refs[`cellInput-${rowIndex}-${columnIndex}`];
                const inputRef = inputRefs ? inputRefs[0] : "";
                if (inputRef) {
                    inputRef.focus();
                }
            });
        }
        handleBlur(rowIndex, columnIndex) {
            const cellKey = `${rowIndex}_${columnIndex}`;
            this.$delete(this.editingCells, cellKey);
            this.checkFileData();
        }

        initCheckTable() {
            if (this.fileDataArr && this.fileDataArr[0]) {
                this.checkColumns = this.fileDataArr[0].map((item) => {
                    return {
                        title: item,
                        key: item,
                    };
                });
                this.checkData = this.fileDataArr.slice(1).map((item, rowIndex) => {
                    let obj = {};
                    this.fileDataArr[0].forEach((temp, columnIndex) => {
                        obj[temp] = item[columnIndex];
                    });
                    return obj;
                });
            }
        }

        checkErrArr = [];
        checkFileData(fromFirst?: boolean) {
            let arr = [];
            let ts = this;
            const firstColData = [],
                secondColData = [];
            this.checkData.forEach((item) => {
                firstColData.push(item[this.fileDataArr[0][0]]);
                secondColData.push(item[this.fileDataArr[0][1]]);
            });

            const result = this.detectCycle(firstColData, secondColData);

            function setErrPoints() {
                ts.checkData.forEach((item, index) => {
                    arr.push(`${index}-1`);
                });
                ts.checkTipStr = "noReports";
                ts.checkErrArr = arr;
            }

            if (result) {
                firstColData.forEach((item, index) => {
                    if (result.indexOf(item) > -1) {
                        arr.push(`${index}-0`);
                    }
                });
                secondColData.forEach((item, index) => {
                    if (result.indexOf(item) > -1) {
                        arr.push(`${index}-1`);
                    }
                });
                this.checkErrArr = arr;
                ts.checkTipStr = "loop";
                return;
            }

            let duplicateArr = this.findDuplicateIndices(firstColData);
            if (duplicateArr && duplicateArr.length > 0) {
                duplicateArr.forEach((item) => {
                    item.indices.forEach((temp) => {
                        arr.push(`${temp}-0`);
                    });
                });
                this.checkErrArr = arr;
                ts.checkTipStr = "uniqueness";
                return;
            }

            if (this.fileDataArr[0][1] !== "ReportsTo" && this.fileDataArr[0][1] !== "直接上级") {
                setErrPoints();
                return;
            } else {
                let haveCommon = this.haveCommonElements(firstColData, secondColData);
                if (!haveCommon) {
                    setErrPoints();
                    return;
                } else {
                    secondColData.forEach((item, index) => {
                        if (firstColData.indexOf(item) === -1) {
                            arr.push(`${index}-1`);
                        }
                    });
                    if (arr.length > 1) {
                        this.checkErrArr = arr;
                        ts.checkTipStr = "reportsErr";
                        return;
                    }
                }
            }

            this.$nextTick(() => {
                if (fromFirst && this.checkTipStr === "success") {
                    this.clickBtn(1, false);
                }
            });
        }

        findDuplicateIndices(arr) {
            const elementToIndices = new Map();
            const duplicateIndices = [];

            for (let i = 0; i < arr.length; i++) {
                const element = arr[i];

                if (elementToIndices.has(element)) {
                    const firstIndex = elementToIndices.get(element);
                    duplicateIndices.push({ element, indices: [firstIndex, i] });
                } else {
                    elementToIndices.set(element, i);
                }
            }

            return duplicateIndices;
        }

        haveCommonElements(array1, array2) {
            const uniqueArray1 = new Set(array1);
            const uniqueArray2 = new Set(array2);
            const mergedUniqueArray = new Set([...uniqueArray1, ...uniqueArray2]);
            return uniqueArray1.size + uniqueArray2.size !== mergedUniqueArray.size;
        }

        detectCycle(array1, array2) {
            const map = new Map(); // 用于存储每个人的上级
            const visited = new Set(); // 用于记录已经访问过的节点
            const stack = []; // 用于 DFS 的栈
            let cycle = []; // 用于存储检测到的循环

            // 构建上级关系映射
            for (let i = 0; i < array1.length; i++) {
                map.set(array1[i], array2[i]);
            }

            // 深度优先搜索函数
            function dfs(node) {
                if (visited.has(node)) {
                    // 如果已经访问过，则找到了循环
                    return true;
                }

                visited.add(node);
                stack.push(node);

                const parent = map.get(node);

                if (parent !== undefined && dfs(parent)) {
                    // 如果上级节点也返回 true，则表示找到了循环
                    cycle = [...stack];
                    return true;
                }

                stack.pop();
                return false;
            }

            // 对 array1 中的每个节点进行 DFS
            for (let node of array1) {
                if (dfs(node)) {
                    break; // 一旦找到循环，就退出循环
                }
                visited.clear(); // 重置 visited 集合以进行下一次搜索
                stack.length = 0; // 重置栈以进行下一次搜索
            }

            return cycle.length > 0 ? cycle : null; // 返回找到的循环或 null（如果没有循环）
        }

        // orientation = 1;
        orientationList = [
            {
                value: 0,
                label: "left",
            },
            {
                value: 1,
                label: "top",
            },
            {
                value: 2,
                label: "right",
            },
            {
                value: 3,
                label: "bottom",
            },
        ];
        forPage = "forOnePage";

        changeRow(type, index) {
            if (type === "up" && index > 0) {
                [this.pageThreeData[index - 1], this.pageThreeData[index]] = [this.pageThreeData[index], this.pageThreeData[index - 1]];
            }
            if (type === "down" && index < this.pageThreeData.length - 1) {
                [this.pageThreeData[index], this.pageThreeData[index + 1]] = [this.pageThreeData[index + 1], this.pageThreeData[index]];
            }
            this.pageThreeData = [...this.pageThreeData];
            this.submitData["orderArr"] = this.pageThreeData.map((item) => {
                return item.basename;
            });
        }

        get showPhoto() {
            return this.$store.state.orgchart.showPhoto;
        }
        get calcTextWrap() {
            return this.$store.state.orgchart.textWrap ? "wrap" : "nowrap";
        }
        get contentLayoutType() {
            return this.$store.state.orgchart.btnType || 0;
        }
        initSubmitData() {
            this.submitData["showPhoto"] = this.showPhoto;
            this.submitData["orientation"] = this.contentLayoutType;
            this.submitData["textWrap"] = this.calcTextWrap;
            this.orientationDisp = !this.$store.state.orgchart.showPhoto;
        }
        orientationDisp = false;
        changeShowPhoto(val) {
            this.orientationDisp = !val;
        }

        mounted() {}

        created() {
            document.addEventListener("keydown", this.keyboardEvent);
            this.initSubmitData();
        }
        beforeDestroy() {
            document.removeEventListener("click", this.closeBox);
            document.removeEventListener("click", this.closeColumn);
            document.removeEventListener("click", this.closeType);
            document.removeEventListener("keydown", this.keyboardEvent);
        }
    }
</script>
<i18n>
{
  "zh": {
    "OrgChartImport": {
      "title": "导入数据生成组织架构图",
      "description": {
        "title_one": "导入存有您组织组织数据的表单，导入前确保：",
        "textone": "1、每一列数据都有名称，即表单的第一行是名单行",
        "texttwo": "2、雇员数据需包含用于识别上下级关系的上级的雇员ID或姓名",
        "textthree": "3、导入文件为以下格式之一(.xlsx .xls .csv .txt)",
        "title_two": "为了得到正确的组织关系图，您需要了解雇员的上级是谁。在此您需要正确的指定雇员的上级（向谁汇报）所在的列。"
      },
      "download": {
        "title": "下载范例文件",
        "file": "Sample.xlsx"
      },
      "importBtn": "浏览",
      "importText": "请选择文件",
      "link": "如何使用数据创建组织结构图",
      "url": "https://www.edrawmax.cn/support/Orgchart",
      "remind": {
        "title": "注意：",
        "text": "当表单中姓和名被分为两列，而且雇员的上级列中数据是全名的，需正确设置姓和名并勾选全名选项。",
        "checkbox": "使用全名"
      },
      "table": {
        "title": "请选择需要显示在组织结构图形状中的项",
        "show": "显示",
        "name": "名称",
        "column": "匹配到Edraw Max的列",
        "type": "类型"
      },
      "btnbox": {
        "prev": "上一步",
        "next": "下一步",
        "complete": "完成",
        "cancel": "取消"
      },
      "chooseFileTitle": "选择包含组织架构图信息的文件（*.txt *.csv *.xls *.xlsx)",
      "contentTitle": "文件内容格式参考",
      "descriptionContent": "注：前两列将帮助你完成组织结构图的层级关系对应，第一列可以是姓名、工号、ID等，注意需要确保数据唯一性。第二列“直接上级”需要对应到第一列的内容。",
      "downloadTitle": "您可以直接下载模板进行套用",
      "downloadBtn": "下载文件模板",
      "helpTip": "仍然有问题？",
      "helpBtn": "查看帮助",
      "checkTitle": "汇报关系检测",
      "setCarTitle": "设置在卡片上的信息显示"
    },
    "fullName": "全名/姓",
    "lastName": "名称",
    "reportTo": "上级（向谁汇报）",
    "isAssistant": "助手",
    "none": "无",
    
    "tableData": {
        "th":{
            "name": "姓名",
            "reports": "直接上级",
            "title": "职位",
            "department": "部门",
            "mobile": "手机",
            "email": "邮箱",
            "info": "其他自定义信息"
        },
        "td": {
            "name1": "张三",
            "name2": "李四",
            "name3": "王五",
            "name4": "赵六",
            "name5": "刘七",
            "title1": "CEO",
            "title2": "采购经理",
            "title3": "采购员",
            "title4": "销售经理",
            "title5": "销售员",
            "department1": "采购部",
            "department2": "销售部"
        }
    },
    "checkTip": {
        "loop": "经检测，第二列有部分汇报关系有误，已为您做了标记。判断是出现了循环汇报，请重新导入或直接在下面表格中修改。",
        "uniqueness": "经检测，第一列有重复内容，请确保第一列数据的唯一性。继续创建会导致绘图无法成型，建议重新导入或直接在下面表格中修改。",
        "noReports": "经检测，您的数据中没有识别到汇报关系。请确保第二列是“直接上级”，且内容和第一列对应。继续创建会导致绘图无法成型，建议修改后重新导入。（注：如果您使用的是旧模板，需要将'直接上级'这一列调整为第二列再进行导入。）",
        "reportsErr": "经检测，第二列有部分汇报关系有误，已为您做了标记。有可能和第一列的内容没对应上，继续创建会导致绘图无法成型，建议修改后重新导入或直接在下面表格中修改。",
        "success": "经检测，您的汇报关系已建立正确，可以继续进行下一步操作。"
    },
    "setPhoto": "照片设置",
    "showPhoto": "显示照片",
    "left": "左",
    "top": "上",
    "right": "右",
    "bottom": "下",
    "setText": "文字设置",
    "setTextWrap": "文字换行",
    "setTextNoWrap": "卡片宽度适应文字",
    "setCardInfo": "卡片信息设置",
    "info": "信息",
    "showHidden": "显示/隐藏",
    "toTop": "向上",
    "toBottom": "向下",
    "forOnePage": "将组织结构图展示在一页内。",
    "forMorePage": "显示拆分的组织结构图到不同页面。"
  },
  "en": {
    "OrgChartImport": {
      "title": "Import Data to Create Org Chart",
      "description": {
        "title_one": "Import a form with your organization data, please confirm the following before importing：",
        "textone": "1、Each column of data has a name，that is,  the first line of the form is the name list.",
        "texttwo": "2、Employee data must include the employee ID or name of the superior to identify the relationship between the superior and the subordinate.",
        "textthree": "3、Import file with one of the following formats (.xlsx .xls .csv .txt)",
        "title_two": "In order to get the right organizational diagram, you need to know who your employees'superior are. Here you need to correctly specify the column in which the employee's superior exists(to whom is reported)."
      },
      "download": {
        "title": "Download Samples",
        "file": "Sample.xlsx"
      },
      "importBtn": "Browse",
      "importText": "please select file",
      "link": "How to Create Org Chart by Importing Data Files",
      "url": "https://edrawmax.wondershare.com/guide/create-org-chart-from-scratch.html",
      "remind": {
        "title": "Note:",
        "text": "If the first name and family name in the form are divided into two columns, and the data in the employee's superior column is the full name, please set the first and last names correctly and select the FullName option.",
        "checkbox": "checkbox-use full name"
      },
      "table": {
        "title": "Please select data file",
        "show": "Show",
        "name": "Name",
        "column": "Match to the column of EdrawMax",
        "type": "Type"
      },
      "btnbox": {
        "prev": "Previous",
        "next": "Next",
        "complete": "Done",
        "cancel": "Cancel"
      },
      "chooseFileTitle": "Locate the file that your organizational chart information:（*.txt *.csv *.xls *.xlsx)",
      "contentTitle": "The following example shows you how to format your organizational chart",
      "descriptionContent": "Note: The first two columns help establish hierarchical relationships in the organizational chart. The first column can include employee names or IDs, which should be unique. The second column 'Reports To' must correspond to the first column.",
      "downloadTitle": "You can download and use the template",
      "downloadBtn": "Download Template",
      "helpTip": "Still have questions?",
      "helpBtn": "View Guide",
      "checkTitle": "Reporting Relationship Check",
      "setCarTitle": "Display on Cards"
    },
    "fullName": "*Full Name/First Name",
    "lastName": "Last Name",
    "reportTo": "*Report To",
    "isAssistant": "is Assistant",
    "none": "none",

    "tableData": {
        "th":{
            "name": "Name",
            "reports": "ReportsTo",
            "title": "Title",
            "department": "Department",
            "mobile": "Mobile Phone",
            "email": "Email",
            "info": "Other Info"
        },
        "td": {
            "name1": "Jim Grenn",
            "name2": "Derek Lee",
            "name3": "Ruth",
            "name4": "James Mosely",
            "name5": "Julie Krause",
            "title1": "CEO",
            "title2": "CFO",
            "title3": "Cashier",
            "title4": "Sales Manager",
            "title5": "Salesman",
            "department1": "Finacial Department",
            "department2": "Sales Department"
        }
    },
    "checkTip": {
        "loop": "Some reporting relationships in the second column are incorrect and have been marked for your reference. It appears that an infinite loop has occurred. Please re-import the data or correct it directly in the table below.",
        "uniqueness": "There are duplicate entries in the first column. Proceeding will prevent the diagram from generating correctly. Please re-import the data or correct it directly in the table below.",
        "noReports": "No reporting relationships were found in your data. Please ensure the second column is 'Reports To' and corresponds to the first column. Proceeding will prevent the diagram from being generated correctly. Please make the necessary changes and re-import the data. (Note: If you're using an old template, move the 'Reports To' column to the second column before importing.)",
        "reportsErr": "Some reporting relationships in the second column are incorrect and have been marked for your reference. This may be due to a mismatch with the first column. Proceeding will prevent the diagram from being generated correctly. Please make the necessary changes and re-import the data or correct it directly in the table below.",
        "success": "Your reporting relationships have been verified as correct. You may proceed to the next step."
    },
    "setPhoto": "Photo",
    "showPhoto": "Show photo",
    "left": "Left",
    "top": "Top",
    "right": "Right",
    "bottom": "Bottom",
    "setText": "Text",
    "setTextWrap": "Wrap text",
    "setTextNoWrap": "Auto expand card width to fit text",
    "setCardInfo": "Card Information",
    "info": "Property",
    "showHidden": "Show/Hide",
    "toTop": "Up",
    "toBottom": "Down",
    "forOnePage": "Display the organization on one page",
    "forMorePage": "Display the seperated organization on each page"
  },
  "fr": {
    "OrgChartImport": {
      "title": "Importer des données pour créer un organigramme",
      "description": {
        "title_one": "Avant d'importer un formulaire qui stocke les données de votre organisation,  veuillez assurer-vous:",
        "textone": "1. Chaque colonne de données a un nom ， c'est-à-dire que la première ligne du formulaire est la liste des noms.",
        "texttwo": "2. Les données de l'employé doivent inclure l'ID ou le nom de l'employé du supérieur utilisé pour identifier la relation supérieur-subordonné",
        "textthree": "3. Le fichier d'importation est dans l'un des formats suivants (.xlsx.xls.csv.txt)",
        "title_two": "Afin d'obtenir le bon organigramme, vous devez savoir qui sont les supérieurs de vos employés. Ici, vous devez spécifier correctement la colonne dans laquelle se trouve le supérieur de l'employé (à qui est rapporté)."
      },
      "download": {
        "title": "Télécharger l'exemple de fichier",
        "file": "Sample.xlsx"
      },
      "importBtn": "Parcourir",
      "importText": "Veuillez sélectionner votre fichier",
      "link": "Comment créer un organigramme à l'aide de données",
      "url": "https://edrawmax.wondershare.com/guide/create-org-chart-from-scratch.html",
      "remind": {
        "title": "Remarque:",
        "text": "Si le prénom et le nom de famille du formulaire sont divisés en deux colonnes et que les données de la colonne supérieure de l'employé sont le nom complet, veuillez définir correctement le prénom et le nom et sélectionner l'option Nom complet.",
        "checkbox": "Case à Cocher - Nom Utile"
      },
      "table": {
        "title": "Veuillez sélectionner un fichier de base de données",
        "show": "Afficher",
        "name": "Nom",
        "column": "Correspond à la colonne d'EdrawMax",
        "type": "Type"
      },
      "btnbox": {
        "prev": "Précédent",
        "next": "Prochain",
        "complete": "Complet",
        "cancel": "Annuler"
      },
      "chooseFileTitle": "Localisez le fichier qui contient les informations de votre organigramme:(*.txt *.csv *.xls *.xlsx)",
      "contentTitle": "L&apos;exemple suivant vous montre comment mettre en forme votre organigramme",
      "descriptionContent": "Remarque : les deux premières colonnes permettent de définir les relations hiérarchiques dans l&apos;organigramme. La première colonne peut contenir les noms ou les ID des employés, qui doivent être uniques. La deuxième colonne « Rapport hiérarchique » doit concorder avec la première colonne.",
      "downloadTitle": "Vous pouvez télécharger et utiliser le modèle",
      "downloadBtn": "Télécharger le modèle",
      "helpTip": "Vous avez d&apos;autres questions ?",
      "helpBtn": "Afficher le guide",
      "checkTitle": "Vérification de la relation hiérarchique",
      "setCarTitle": "Afficher sur Cartes"
    },
    "fullName": "Nom / prénom",
    "lastName": "Nom",
    "reportTo": "Afficher le guide",
    "isAssistant": "assistant",
    "none": "rien",

    "tableData": {
        "th":{
            "name": "Nom",
            "reports": "Rapports à",
            "title": "Titre",
            "department": "Département",
            "mobile": "Téléphone portable",
            "email": "Email",
            "info": "Autres informations"
        },
        "td": {
            "name1": "Jim Grenn",
            "name2": "Derek Lee",
            "name3": "Ruth",
            "name4": "James Mosely",
            "name5": "Julie Krause",
            "title1": "CEO",
            "title2": "CFO",
            "title3": "Cashier",
            "title4": "Sales Manager",
            "title5": "Salesman",
            "department1": "Finacial Department",
            "department2": "Sales Department"
        }
    },
    "checkTip": {
        "loop": "Certaines relations hiérarchiques dans la deuxième colonne sont incorrectes et ont été marquées à titre de référence. Le système semble avoir généré une boucle infinie. Veuillez réimporter les données ou les corriger directement dans le tableau ci-dessous.",
        "uniqueness": "La première colonne contient des entrées en double. Si vous continuez, l&apos;organigramme ne sera pas généré correctement. Veuillez réimporter les données ou les corriger directement dans le tableau ci-dessous.",
        "noReports": "ucune relation hiérarchique n&apos;a été trouvée dans vos données. Veuillez vous assurer que la deuxième colonne est intitulée « Supérieur hiérarchique » et qu&apos;elle concorde avec la première colonne. Si vous continuez, l&apos;organigramme ne sera pas généré correctement. Veuillez apporter les modifications nécessaires et réimporter les données. (Remarque : si vous utilisez un ancien modèle, déplacez la colonne « Supérieur hiérarchique » vers la deuxième colonne avant l&apos;importation.)",
        "reportsErr": "Certaines relations hiérarchiques dans la deuxième colonne sont incorrectes et ont été marquées à titre de référence. Cela peut être dû à une incohérence avec la première colonne. Si vous continuez, l&apos;organigramme ne sera pas généré correctement. Veuillez apporter les modifications nécessaires et réimporter les données ou les corriger directement dans le tableau ci-dessous.",
        "success": "Les relations hiérarchiques ont été vérifiées. Vous pouvez passer à l&apos;étape suivante."
    },
    "setPhoto": "Photo",
    "showPhoto": "Afficher la photo",
    "left": "Gauche",
    "top": "Mettre en arrière-plan",
    "right": "Droit",
    "bottom": "Mettre en avant-plan",
    "setText": "Text",
    "setTextWrap": "Ajuster le texte",
    "setTextNoWrap": "Développer automatiquement",
    "setCardInfo": "Informations de carte",
    "info": "Propriété",
    "showHidden": "Afficher/Masquer",
    "toTop": "Vers le haut",
    "toBottom": "Vers le bas",
    "forOnePage": "Afficher l&apos;organisation sur une page",
    "forMorePage": "Afficher l&apos;organisation séparée sur toutes les pages"
  },
  "de": {
    "OrgChartImport": {
      "title": "Daten importieren, um Organigramm zu erstellen",
      "description": {
        "title_one": "Importieren Sie ein Formular mit Ihren Organisationsdaten. Bitte bestätigen Sie, bevor Sie Folgendes importieren:",
        "textone": "1. Jede Datenspalte hat einen Namen, d.h. die erste Zeile des Formulars ist die Namensliste.",
        "texttwo": "2 .Mitarbeiterdaten müssen die Mitarbeiter-ID oder den Namen des Vorgesetzten enthalten, um die Beziehung zwischen dem Vorgesetzten und dem Untergebenen zu identifizieren.",
        "textthree": "3. Datei im einen der folgenden Formate importieren (.xlsx .xls .csv .txt)",
        "title_two": "Um das richtige Organigramm zu erhalten, müssen Sie wissen, wer der Vorgesetzte Ihrer Mitarbeiter ist. Hier müssen Sie die Spalte korrekt angeben, in der der Vorgesetzte des Mitarbeiters existiert (an wen berichtet wird)."
      },
      "download": {
        "title": "Beispiele herunterladen",
        "file": "Beispiel.xlxs"
      },
      "importBtn": "Browsen",
      "importText": "Datei auswählen",
      "link": "So erstellen Sie ein Organigramm durch Importieren von Datendateien",
      "url": "https://edrawmax.wondershare.com/guide/create-org-chart-from-scratch.html",
      "remind": {
        "title": "Achtung：",
        "text": "Wenn der Vorname und der Familienname im Formular in zwei Spalten unterteilt sind und die Daten in der übergeordneten Spalte des Mitarbeiters der vollständige Name sind, stellen Sie den Vor- und Nachnamen richtig ein und wählen Sie die Option Vollständiger Name.",
        "checkbox": "Kontrollkästchen Vollständiger Name verwenden"
      },
      "table": {
        "title": "Bitte Datendatei auswählen",
        "show": "Anzeigen",
        "name": "Name",
        "column": "Mit der Spalte von EdrawMax abstimmen",
        "type": "Typ"
      },
      "btnbox": {
        "prev": "Vorhergehend",
        "next": "Nächst",
        "complete": "Erledigt",
        "cancel": "Abbrechen"
      },
      "chooseFileTitle": "Wählen Sie die Datei mit Ihren Gantt-Diagrammdaten: (*.txt *.csv *.xls *.xlsx)",
      "contentTitle": "TDas folgende Beispiel zeigt, wie Sie Ihr Organigramm formatieren",
      "descriptionContent": "Hinweis: Die ersten beiden Spalten dienen dazu, hierarchische Beziehungen im Organigramm herzustellen. Die erste Spalte kann Mitarbeiternamen oder -IDs enthalten, die eindeutig sein müssen. Die zweite Spalte „Berichtet an“ muss mit der ersten Spalte übereinstimmen.",
      "downloadTitle": "Sie können die Vorlage herunterladen und verwenden",
      "downloadBtn": "Vorlage herunterladen",
      "helpTip": "Haben Sie noch Fragen?",
      "helpBtn": "Anleitung anzeigen",
      "checkTitle": "Überprüfung der Berichtsbeziehung",
      "setCarTitle": "Auf Karten anzeigen"
    },
    "fullName": "Vorname",
    "lastName": "Nachname",
    "reportTo": "Vorgesetzter (wem zu melden)",
    "isAssistant": "Assistent",
    "none": "keiner",

    "tableData": {
        "th":{
            "name": "Name",
            "reports": "VorgesetzterIst",
            "title": "Titel",
            "department": "Abteilung",
            "mobile": "Mobiltelefon",
            "email": "E-Mail",
            "info": "Weitere Informationen"
        },
        "td": {
            "name1": "Jim Grenn",
            "name2": "Derek Lee",
            "name3": "Ruth",
            "name4": "James Mosely",
            "name5": "Julie Krause",
            "title1": "CEO",
            "title2": "CFO",
            "title3": "Cashier",
            "title4": "Sales Manager",
            "title5": "Salesman",
            "department1": "Finacial Department",
            "department2": "Sales Department"
        }
    },
    "checkTip": {
        "loop": "Einige Berichtsbeziehungen in der zweiten Spalte sind falsch und wurden zu Ihrer Information markiert. Offenbar ist eine Endlosschleife aufgetreten. Importieren Sie die Daten erneut oder korrigieren Sie sie direkt in der Tabelle unten.",
        "uniqueness": "In der ersten Spalte sind doppelte Einträge vorhanden. Wenn Sie fortfahren, kann das Diagramm nicht korrekt generiert werden. Importieren Sie die Daten erneut oder korrigieren Sie sie direkt in der Tabelle unten.",
        "noReports": "In Ihren Daten wurden keine Berichtsbeziehungen gefunden. Stellen Sie sicher, dass die zweite Spalte „Berichtet an“ lautet und mit der ersten Spalte übereinstimmt. Wenn Sie fortfahren, wird das Diagramm nicht korrekt generiert. Nehmen Sie die erforderlichen Änderungen vor und importieren Sie die Daten erneut. (Hinweis: Wenn Sie eine alte Vorlage verwenden, verschieben Sie die Spalte „Berichtet an“ vor dem Import in die zweite Spalte.)",
        "reportsErr": "Einige Berichtsbeziehungen in der zweiten Spalte sind falsch und wurden zu Ihrer Information markiert. Dies kann auf eine Abweichung von der ersten Spalte zurückzuführen sein. Wenn Sie fortfahren, wird das Diagramm nicht korrekt generiert. Nehmen Sie die erforderlichen Änderungen vor und importieren Sie die Daten erneut oder korrigieren Sie sie direkt in der Tabelle unten.",
        "success": "Ihre Berichtsbeziehungen wurden als korrekt bestätigt. Sie können mit dem nächsten Schritt fortfahren."
    },
    "setPhoto": "Foto",
    "showPhoto": "Foto anzeigen",
    "left": "Links",
    "top": "Oben",
    "right": "Rechts",
    "bottom": "Unten",
    "setText": "Text",
    "setTextWrap": "Text umbrechen",
    "setTextNoWrap": "Automatisch erweitern",
    "setCardInfo": "Informationen zur Karte",
    "info": "Eigenschaft",
    "showHidden": "Ein-/Ausbleden",
    "toTop": "Hoch",
    "toBottom": "Runter",
    "forOnePage": "Organigramm auf einer Seite anzeigen",
    "forMorePage": "Organigramm getrennt auf einzelnen Seiten anzeigen"
  },
  "jp": {
    "OrgChartImport": {
      "title": "データをインポートして組織図を作成",
      "description": {
        "title_one": "組織データを含むフォームをインポートします。その前以下をご確認ください：",
        "textone": "1、データの各列には名称があります。つまり、フォームの最初の行は名称行です。",
        "texttwo": "2、従業員データには、上司と部下の関係を識別するための上司のIDまたは名前を含める必要があります。",
        "textthree": "3、インポートファイルは、次のフォーマットのいずれでよろしいです：.xlsx .xls .csv .txt",
        "title_two": "正しい組織構造を得るために、従業員の上司が誰であるかをわかる必要があります。ここでは、従業員の上司（レポート対象）を正しく指定する必要があります。"
      },
      "download": {
        "title": "サンプルファイルをダウンロード",
        "file": "サンプル.xlsx"
      },
      "importBtn": "参照",
      "importText": "ファイルを選択",
      "link": "データから組織図を作る方法",
      "url": "https://edrawmax.wondershare.com/guide/create-org-chart-from-scratch.html",
      "remind": {
        "title": "ご注意：",
        "text": "フォームにおける苗字と名前が2つの列に分割されて、従業員の上司のデータがフルネームの場合は、苗字と名前を正しく設定して、フルネームオプションにチェックを入れてください。",
        "checkbox": "フルーネーム"
      },
      "table": {
        "title": "データファイルを選択ください。",
        "show": "表示",
        "name": "名称",
        "column": "EdrawMaxの列に合わせる",
        "type": "タイプ"
      },
      "btnbox": {
        "prev": "前に",
        "next": "次へ",
        "complete": "完了",
        "cancel": "キャンセル"
      },
      "chooseFileTitle": "ガントチャート情報を含むファイルを指定：(*.txt *.csv *.xls *.xlsx)",
      "contentTitle": "次の例は、組織図のフォーマット方法を示しています",
      "descriptionContent": "注：最初の2列を使って組織図内の階層関係を設定できます。最初の列には従業員名やIDを含めることができます。これらは一意である必要があります。2列目の「上司」は1列目に対応している必要があります。",
      "downloadTitle": "テンプレートをダウンロードして使用できます",
      "downloadBtn": "テンプレートをダウンロード",
      "helpTip": "まだ不明な点がありますか?",
      "helpBtn": "ガイドを表示",
      "checkTitle": "上下関係の確認",
      "setCarTitle": "カードに表示するもの"
    },
    "fullName": "姓名/姓",
    "lastName": "名前",
    "reportTo": "上司（報告先）",
    "isAssistant": "アシスタント",
    "none": "無し",

    "tableData": {
        "th":{
            "name": "名前",
            "reports": "報告",
            "title": "タイトル",
            "department": "部門",
            "mobile": "携帯電話",
            "email": "Email",
            "info": "その他の情報"
        },
        "td": {
            "name1": "Jim Grenn",
            "name2": "Derek Lee",
            "name3": "Ruth",
            "name4": "James Mosely",
            "name5": "Julie Krause",
            "title1": "CEO",
            "title2": "CFO",
            "title3": "Cashier",
            "title4": "Sales Manager",
            "title5": "Salesman",
            "department1": "Finacial Department",
            "department2": "Sales Department"
        }
    },
    "checkTip": {
        "loop": "2列目の上下関係の中に正しくないものがあるため、参照用にマークされています。無限ループが発生したようです。データを再インポートするか、下の表で直接修正してください。",
        "uniqueness": "1列目に重複したエントリがあります。続行した場合、正しい図が生成されません。データを再インポートするか、下の表で直接修正してください。",
        "noReports": "データに上下関係が見つかりませんでした。2列目が「上司」で、1列目に対応していることを確認してください。続行した場合、正しい図が生成されません。必要な変更を行ってからデータを再インポートしてください。（注意：古いテンプレートを使用している場合は、「上司」列を2列目に移動してからインポートしてください。）",
        "reportsErr": "2列目の上下関係の中に正しくないものがあるため、参照用にマークされています。この原因として、1列目との不整合が考えられます。続行した場合、正しい図が生成されません。必要な変更を行ってからデータを再インポートするか、下の表で直接修正してください。",
        "success": "上下関係が正しいことが確認されました。次のステップに進んでください。"
    },
    "setPhoto": "画像",
    "showPhoto": "写真を表示",
    "left": "左側に並べる",
    "top": "上",
    "right": "右側に並べる",
    "bottom": "下揃え",
    "setText": "テキスト",
    "setTextWrap": "テキストを折り返す",
    "setTextNoWrap": "自動調整",
    "setCardInfo": "カード情報",
    "info": "プロパティ",
    "showHidden": "表示/隠す",
    "toTop": "上側に並べる",
    "toBottom": "下側に並べる",
    "forOnePage": "組織図を1ページに表示します",
    "forMorePage": "組織図を分割して複数のページに表示します"
  },
  "es": {
    "OrgChartImport": {
      "title": "Importar datos para crear organigrama",
      "description": {
        "title_one": "Importe un formulario con los datos de su organización, por favor confirme lo siguiente antes de importar",
        "textone": "1, Cada columna de datos tiene un nombre, es decir, la primera línea de la forma es la lista de nombres.",
        "texttwo": "Los datos del empleado deben incluir el ID del empleado o el nombre del superior para identificar la relación entre el superior y el subordinado",
        "textthree": "3、Import con uno de los siguientes formatos (.xlsx .xls .csv .txt)",
        "title_two": "Para obtener el diagrama de organización correcto, necesitas saber quién es el superior de tus empleados. Aquí necesitas especificar correctamente la columna en la que existe el superior del empleado (a quien se informa)"
      },
      "download": {
        "title": "Descargar muestras",
        "file": "Muestra.xlsx"
      },
      "importBtn": "Examinar",
      "importText": "por favor seleccione el archivo",
      "link": "Cómo crear un organigrama importando archivos de datos",
      "url": "https://edrawmax.wondershare.com/guide/create-org-chart-from-scratch.html",
      "remind": {
        "title": "Nota",
        "text": "Si el nombre y el apellido en el formulario están divididos en dos columnas, y los datos de la columna superior del empleado son el nombre completo, por favor establezca correctamente el nombre y los apellidos y seleccione la opción FullName",
        "checkbox": "casilla de verificación - usar nombre completo"
      },
      "table": {
        "title": "Por favor, seleccione el archivo de datos",
        "show": "Mostrar",
        "name": "Nombre",
        "column": "Coincide con la columna de EdrawMax",
        "type": "Tipo"
      },
      "btnbox": {
        "prev": "Anterior",
        "next": "Siguente",
        "complete": "finalizar",
        "cancel": "Cancelar"
      },
      "chooseFileTitle": "Buscar el archivo que contiene la información de Gráfico de Gantt: (*.txt *.csv *.xls *.xlsx)",
      "contentTitle": "El ejemplo siguiente muestra cómo dar formato al organigrama",
      "descriptionContent": "Nota: Las dos primeras columnas ayudan a establecer relaciones jerárquicas en el organigrama. La primera columna puede incluir nombres o ID de empleado, que deben ser únicos. La segunda columna &quot;Informa a&quot; debe corresponder a la primera columna.",
      "downloadTitle": "Puedes descargar y utilizar la plantilla",
      "downloadBtn": "Descargar plantilla",
      "helpTip": "¿Todavía tienes preguntas?",
      "helpBtn": "Ver guía",
      "checkTitle": "Comprobación de las relaciones de informes",
      "setCarTitle": "Mostrar en tarjetas"
    },
    "fullName": "Nombre completo / Nombre",
    "lastName": "Apellido",
    "reportTo": "Reportar a",
    "isAssistant": "Asistente",
    "none": "NO",

    "tableData": {
        "th":{
            "name": "Nombre",
            "reports": "Informes a",
            "title": "Título",
            "department": "Departamento",
            "mobile": "Teléfono personal",
            "email": "Email",
            "info": "tra información"
        },
        "td": {
            "name1": "Jim Grenn",
            "name2": "Derek Lee",
            "name3": "Ruth",
            "name4": "James Mosely",
            "name5": "Julie Krause",
            "title1": "CEO",
            "title2": "CFO",
            "title3": "Cashier",
            "title4": "Sales Manager",
            "title5": "Salesman",
            "department1": "Finacial Department",
            "department2": "Sales Department"
        }
    },
    "checkTip": {
        "loop": "Algunas de las relaciones de informes de la segunda columna son incorrectas y se han marcado como referencia. Parece que se ha producido un bucle infinito. Vuelve a importar los datos o corrígelos directamente en la siguiente tabla.",
        "uniqueness": "Hay entradas duplicadas en la primera columna. Continuar con el proceso evitará que el diagrama se genere correctamente. Vuelve a importar los datos o corrígelos directamente en la siguiente tabla.",
        "noReports": "No se han encontrado relaciones de informes en tus datos. Asegúrate de que la segunda columna es &quot;Informa a&quot; y se corresponde con la primera columna. Continuar con el proceso evitará que el diagrama se genere correctamente. Realiza los cambios necesarios y vuelve a importar los datos. (Nota: Si utilizas una plantilla antigua, mueve la columna &quot;Informa a&quot; a la segunda columna antes de importar.)",
        "reportsErr": "Algunas de las relaciones de informes de la segunda columna son incorrectas y se han marcado como referencia. Esto puede deberse a una discrepancia con la primera columna. Continuar con el proceso evitará que el diagrama se genere correctamente. Realiza los cambios necesarios y vuelve a importar los datos o corrígelos directamente en la siguiente tabla.",
        "success": "Se ha comprobado que las relaciones de informes son correctas. Puedes continuar con el siguiente paso."
    },
    "setPhoto": "Foto",
    "showPhoto": "Mostrar foto",
    "left": "Izquierdo",
    "top": "Superior",
    "right": "Derecho",
    "bottom": "Inferior",
    "setText": "Escribir",
    "setTextWrap": "Ajustar texto",
    "setTextNoWrap": "Ampliar automáticamente",
    "setCardInfo": "Tarjeta de Información",
    "info": "Propiedad",
    "showHidden": "Mostrar/Esconder",
    "toTop": "Arriba",
    "toBottom": "Abajo",
    "forOnePage": "Mostrar la organización en una página",
    "forMorePage": "Mostrar la organización separada en cada página"
  },
  "pt": {
    "OrgChartImport": {
      "title": "Importar dados para criar organograma",
      "description": {
        "title_one": "Importar um formulário com os seus dados de organização, por favor, confirmar o seguintes antes de importar：",
        "textone": "1、Cada coluna de dados tem um nome, ou seja, a primeira linha do formulário é o nome da lista.",
        "texttwo": "2、Os dados do funcionário devem incluir o ID do funcionário ou o nome do superior para identificar a relação entre o superior e o subordinado.",
        "textthree": "3、Importar ficheiro com um dos seguintes formatos (.xlsx .xls .csv .txt)",
        "title_two": "Para obter o organograma correto, é necessário saber quais são os superiores dos seus funcionários. Aqui é necessário especificar corretamente a coluna na qual o superior do funcionário existe (para quem é reportado)."
      },
      "download": {
        "title": "Descarregar Amostras",
        "file": "Amostra.xlsx"
      },
      "importBtn": "Navegar",
      "importText": "por favor, selecionar ficheiro",
      "link": "Como Criar Organograma Importando Ficheiros de Dados",
      "url": "https://edrawmax.wondershare.com/guide/create-org-chart-from-scratch.html",
      "remind": {
        "title": "Nota:",
        "text": "Se o primeiro nome e o nome de família no formulário estão divididos em duas colunas, e os dados na coluna superior do funcionário são o nome completo, por favor, definir o primeiro e último nome corretamente e selecionar a opção Nome Completo.",
        "checkbox": "caixa de seleção - usar nome completo"
      },
      "table": {
        "title": "Por favor, selecionar ficheiro de dados",
        "show": "Mostrar",
        "name": "Nome",
        "column": "Corresponder à coluna do EdrawMax",
        "type": "Tipo"
      },
      "btnbox": {
        "prev": "Anterior",
        "next": "Seguinte",
        "complete": "Concluído",
        "cancel": "Cancelar"
      },
      "chooseFileTitle": "Localizar o arquivo que contém a informação do seu gráfico de Gantt: (*.txt *.csv *.xls *.xls *.xlsx)",
      "contentTitle": "O exemplo a seguir mostra como formatar seu organograma",
      "descriptionContent": "Observação: as duas primeiras colunas ajudam a estabelecer relacionamentos hierárquicos no organograma. A primeira coluna pode incluir nomes ou IDs de funcionários, que devem ser únicos. A segunda coluna &quot;Reporta-se a&quot; deve corresponder à primeira coluna.",
      "downloadTitle": "Você pode baixar e usar o model",
      "downloadBtn": "Baixar modelo",
      "helpTip": "Ainda tem dúvidas?",
      "helpBtn": "Exibir guia",
      "checkTitle": "Verificação de relacionamento de subordinação",
      "setCarTitle": "Exibir em cartões"
    },
    "fullName": "Nome Completo / Primeiro Nome",
    "lastName": "Sobrenome",
    "reportTo": "Reportar para",
    "isAssistant": "é assistente",
    "none": "não",

    "tableData": {
        "th":{
            "name": "Nome",
            "reports": "RelatóriosPara",
            "title": "Título",
            "department": "Departamento",
            "mobile": "Mobile Phone",
            "email": "Email",
            "info": "Outras informações"
        },
        "td": {
            "name1": "Jim Grenn",
            "name2": "Derek Lee",
            "name3": "Ruth",
            "name4": "James Mosely",
            "name5": "Julie Krause",
            "title1": "CEO",
            "title2": "CFO",
            "title3": "Cashier",
            "title4": "Sales Manager",
            "title5": "Salesman",
            "department1": "Finacial Department",
            "department2": "Sales Department"
        }
    },
    "checkTip": {
        "loop": "lguns relacionamentos de subordinação na segunda coluna estão incorretos e foram marcados para sua referência. Parece que ocorreu um loop infinito. Importe novamente os dados ou corrija-os diretamente na tabela abaixo.",
        "uniqueness": "Há entradas duplicadas na primeira coluna. Continuar impedirá que o diagrama seja gerado corretamente. Importe novamente os dados ou corrija-os diretamente na tabela abaixo.",
        "noReports": "Nenhum relacionamento de subordinação foi encontrado em seus dados. Certifique-se de que a segunda coluna seja &quot;Reporta-se a&quot; e corresponda à primeira coluna. Continuar impedirá que o diagrama seja gerado corretamente. Faça as alterações necessárias e importe os dados novamente. (Observação: se você estiver usando um modelo antigo, mova a coluna &quot;Reporta-se a&quot; para a segunda coluna antes de importar.)",
        "reportsErr": "Alguns relacionamentos de subordinação na segunda coluna estão incorretos e foram marcados para sua referência. Isso pode ser devido a uma discrepância com a primeira coluna. Continuar impedirá que o diagrama seja gerado corretamente. Faça as alterações necessárias e reimporte os dados ou corrija-os diretamente na tabela abaixo.",
        "success": "Seus relacionamentos de subordinação foram confirmados como corretos. Você pode prosseguir para a próxima etapa."
    },
    "setPhoto": "Foto",
    "showPhoto": "Mostrar foto",
    "left": "Esquerda",
    "top": "Topo",
    "right": "Direita",
    "bottom": "Inferior",
    "setText": "Texto",
    "setTextWrap": "Quebrar linha de texto",
    "setTextNoWrap": "Expandir automaticamente",
    "setCardInfo": "Informações de Cartão",
    "info": "Propriedade",
    "showHidden": "Mostrar/Ocultar",
    "toTop": "Cima",
    "toBottom": "Baixo",
    "forOnePage": "Mostra a organização numa página",
    "forMorePage": "Mostra a organização separada em cada página"
  },
  "it": {
    "OrgChartImport": {
      "title": "Importa dati per creare organigramma",
      "description": {
        "title_one": "Importazione di un modulo contenente i dati organizzativi. Prima di procedere con l’importazione, si prega di verificare che le seguenti condizioni siano rispettate:",
        "textone": "1. Ogni colonna di dati deve essere dotata di un nome; la prima riga del modulo deve comprendere l’elenco dei nomi.",
        "texttwo": "2. I dati di impiegati e impiegate devono comprendere l’ID o il nome del/della superiore, in modo tale che sia possibile identificare la relazione tra superiore e subordinato.",
        "textthree": "3. Il file da importare deve essere in uno dei seguenti formati: .xlsx .xls .csv .txt.",
        "title_two": "Affinché l’organigramma risulti corretto, è necessario determinare chi siano i/le superiori. Specificare la colonna comprendente i/le superiori cui ciascun dipendente fa riferimento."
      },
      "download": {
        "title": "Scarica Esempi",
        "file": "Esempio.xlsx"
      },
      "importBtn": "Sfoglia",
      "importText": "Si prega di selezionare un file",
      "link": "Come Creare un Organigramma Importando File di Dati",
      "url": "https://edrawmax.wondershare.com/guide/create-org-chart-from-scratch.html",
      "remind": {
        "title": "Nota:",
        "text": "Se nomi e cognomi sono divisi in due colonne e i dati relativi ai/alle superiori comprendono i nomi completi, si prega di impostare correttamente nomi e cognomi e di selezionare l’opzione Nome Completo.",
        "checkbox": "Usa Nome Completo"
      },
      "table": {
        "title": "Si prega di selezionare un file di dati",
        "show": "Mostra",
        "name": "Nome",
        "column": "Adatta alle colonne di EdrawMax",
        "type": "Tipo"
      },
      "btnbox": {
        "prev": "Precedente",
        "next": "Successivo",
        "complete": "Fatto",
        "cancel": "Annulla"
      },
      "chooseFileTitle": "Trova il file contenente le informazioni del grafico gantt: (*.txt *.csv *.xls *.xlsx)",
      "contentTitle": "L&aposNota: le prime due colonne consentono di stabilire relazioni gerarchiche nell&apos;organigramma. La prima colonna può includere nomi o ID dei dipendenti che devono essere univoci. La seconda colonna &quot;Segnala&quot; deve corrispondere alla prima colonna.",
      "downloadTitle": "È possibile scaricare e utilizzare il modello",
      "downloadBtn": "Scarica modello",
      "helpTip": "Hai altre domande?",
      "helpBtn": "Visualizza guida",
      "checkTitle": "Verifica della relazione tra segnalazioni",
      "setCarTitle": "Visualizza su schede"
    },
    "fullName": "Nome completo /Nome",
    "lastName": "Cognome",
    "reportTo": "Superiore (a chi segnalare)",
    "isAssistant": "è Assistente",
    "none": "no",

    "tableData": {
        "th":{
            "name": "Nome",
            "reports": "Segnala a",
            "title": "Titolo",
            "department": "Dipartimento",
            "mobile": "MTelefono",
            "email": "Email",
            "info": "Altre info"
        },
        "td": {
            "name1": "Jim Grenn",
            "name2": "Derek Lee",
            "name3": "Ruth",
            "name4": "James Mosely",
            "name5": "Julie Krause",
            "title1": "CEO",
            "title2": "CFO",
            "title3": "Cashier",
            "title4": "Sales Manager",
            "title5": "Salesman",
            "department1": "Finacial Department",
            "department2": "Sales Department"
        }
    },
    "checkTip": {
        "loop": "Alcune relazioni tra segnalazioni nella seconda colonna non sono corrette e sono state contrassegnate come riferimento. Sembra che si sia verificato un ciclo infinito. Importa nuovamente i dati o correggili direttamente nella tabella seguente.",
        "uniqueness": "Nella prima colonna sono presenti voci duplicate. Continuando, il diagramma non verrà generato correttamente. Importa nuovamente i dati o correggili direttamente nella tabella seguente.",
        "noReports": "Non sono state trovate relazioni tra segnalazioni nei dati. Assicurati che la seconda colonna sia &quot;Segnala a&quot; e corrisponda alla prima colonna. Continuando, il diagramma non verrà generato correttamente. Apporta le modifiche necessarie e importa nuovamente i dati (nota: se utilizzi un modello precedente, sposta la colonna &quot;Segnala a&quot; nella seconda colonna prima dell&apos;importazione.)",
        "reportsErr": "Alcune relazioni tra segnalazioni nella seconda colonna non sono corrette e sono state contrassegnate come riferimento. Ciò potrebbe essere dovuto a una mancata corrispondenza con la prima colonna. Continuando, il diagramma non verrà generato correttamente. Apporta le modifiche necessarie e importa nuovamente i dati o correggili direttamente nella tabella seguente.",
        "success": "Le relazioni tra segnalazioni sono state verificate come corrette. È possibile continuare con il passaggio successivo."
    },
    "setPhoto": "Foto",
    "showPhoto": "Mostra foto",
    "left": "Sinistra",
    "top": "Superiore",
    "right": "Destra",
    "bottom": "In Basso",
    "setText": "Testo",
    "setTextWrap": "A capo",
    "setTextNoWrap": "Espandi automaticamente",
    "setCardInfo": "Informazioni sulla Card",
    "info": "Proprietà",
    "showHidden": "Mostra/Nascondi",
    "toTop": "Su",
    "toBottom": "Giù",
    "forOnePage": "Mostra l&apos;organizzazione su una sola pagina",
    "forMorePage": "Mostra l&apos;organizzazione separata su ciascuna pagina"
  },
  "tw": {
    "OrgChartImport": {
      "title": "數據導入嚮導",
      "description": {
        "title_one": "導入存有您組織組織數據的表單，導入前確保：",
        "textone": "1、每一列數據都有名稱，即表單的第一行是名單行",
        "texttwo": "2、僱員數據需包含用於識別上下級關係的上級的僱員ID或姓名",
        "textthree": "3、導入檔案為以下格式之一(.xlsx .xls .csv .txt)",
        "title_two": "為了得到正確的組織關係圖，您需要了解僱員的上級是誰。在此您需要正確的指定僱員的上級（向誰匯報）所在的列。"
      },
      "download": {
        "title": "下載範例檔案",
        "file": "Sample.xlsx"
      },
      "importBtn": "瀏覽",
      "importText": "請選擇檔案",
      "link": "如何使用數據建立組織結構圖",
      "url": "https://www.edrawmax.cn/support/Orgchart",
      "remind": {
        "title": "注意：",
        "text": "當表單中姓和名被分為兩列，而且僱員的上級列中數據是全名的，需正確設置姓和名並勾選全名選項。",
        "checkbox": "使用全名"
      },
      "table": {
        "title": "請選擇需要顯示在組織結構圖形狀中的項",
        "show": "顯示",
        "name": "名稱",
        "column": "匹配到Edraw Max的列",
        "type": "類型"
      },
      "btnbox": {
        "prev": "上一步",
        "next": "下一步",
        "complete": "完成",
        "cancel": "取消"
      },
      "chooseFileTitle": "Locate the file that your organizational chart information:（*.txt *.csv *.xls *.xlsx)",
      "contentTitle": "The following example shows you how to format your organizational chart",
      "descriptionContent": "Note: The first two columns help establish hierarchical relationships in the organizational chart. The first column can include employee names or IDs, which should be unique. The second column 'Reports To' must correspond to the first column.",
      "downloadTitle": "You can download and use the template",
      "downloadBtn": "Download Template",
      "helpTip": "Still have questions?",
      "helpBtn": "View Guide",
      "checkTitle": "Reporting Relationship Check",
      "setCarTitle": "Display on Cards"
    },
    "fullName": "全名/姓",
    "lastName": "名稱",
    "reportTo": "上級（向誰匯報）",
    "isAssistant": "助手",
    "none": "無",

    "tableData": {
        "th":{
            "name": "Nom",
            "reports": "直接上级",
            "title": "Titre",
            "department": "Département",
            "mobile": "Téléphone portable",
            "email": "Email",
            "info": "其他自定义信息"
        },
        "td": {
            "name1": "Jim Grenn",
            "name2": "Derek Lee",
            "name3": "Ruth",
            "name4": "James Mosely",
            "name5": "Julie Krause",
            "title1": "CEO",
            "title2": "CFO",
            "title3": "Cashier",
            "title4": "Sales Manager",
            "title5": "Salesman",
            "department1": "Finacial Department",
            "department2": "Sales Department"
        }
    },
    "checkTip": {
        "loop": "经检测，第二列有部分汇报关系有误，已为您做了标记。判断是出现了循环汇报，请重新导入或直接在下面表格中修改。",
        "uniqueness": "经检测，第一列有重复内容，请确保第一列数据的唯一性。继续创建会导致绘图无法成型，建议重新导入或直接在下面表格中修改。",
        "noReports": "经检测，您的数据中没有识别到汇报关系。请确保第二列是“直接上级”，且内容和第一列对应。继续创建会导致绘图无法成型，建议修改后重新导入。（注：如果您使用的是旧模板，需要将ReportsTo这一列调整为第二列再进行导入。）",
        "reportsErr": "经检测，第二列有部分汇报关系有误，已为您做了标记。有可能和第一列的内容没对应上，继续创建会导致绘图无法成型，建议修改后重新导入或直接在下面表格中修改。",
        "success": "经检测，您的汇报关系已建立正确，可以继续进行下一步操作。"
    },
    "setPhoto": "照片设置",
    "showPhoto": "显示照片",
    "left": "左",
    "top": "上",
    "right": "右",
    "bottom": "下",
    "setText": "文字设置",
    "setTextWrap": "文字换行",
    "setTextNoWrap": "卡片宽度适应文字",
    "setCardInfo": "卡片信息设置",
    "info": "信息",
    "showHidden": "显示/隐藏",
    "toTop": "向上",
    "toBottom": "向下",
    "forOnePage": "将组织结构图展示在一页内。",
    "forMorePage": "显示拆分的组织结构图到不同页面。"
  },
  "kr": {
    "OrgChartImport": {
      "title": "데이터 가져오기 안내",
      "description": {
        "title_one": "조직 데이터와 함께 양식을 가져오세요. 가져오기 전에 다음 사항을 확인하세요.",
        "textone": "1.데이터의 각 열에는 이름이 있습니다. 즉, 양식의 첫 번째 줄은 이름 목록입니다.",
        "texttwo": "2.직원 데이터는 상사와 부하 직원의 관계를 식별하기 위해 상사의 이름 또는 직원 ID을 포함해야 합니다.",
        "textthree": "3.다음 형식 중 하나를 사용하여 파일 가져오기 (.xlsx .xls .csv .txt)",
        "title_two": "올바른 조직도를 얻기 위해서는 직원들의 상급자가 누구인지 알아야 합니다. 여기서 직원의 상급자가 있는 열을 올바르게 지정해야 합니다."
      },
      "download": {
        "title": "샘플 다운로드",
        "file": "Sample.xlsx"
      },
      "importBtn": "찾아보기",
      "importText": "파일을 선택하세요.",
      "link": "데이터 파일을 가져와 조직 차트를 만드는 방법",
      "url": "https://www.edrawmax.cn/support/Orgchart",
      "remind": {
        "title": "주의：",
        "text": "양식의 이름과 성이 두 열로 나뉘고 직원의 상위 열에 있는 데이터가 전체 이름인 경우, 이름과 성을 올바르게 설정하고 전체 이름 옵션을 선택하세요.",
        "checkbox": "풀네임 사용"
      },
      "table": {
        "title": "데이터 파일을 선택하세요.",
        "show": "보여주기",
        "name": "이름",
        "column": "EdrawMax 열과 일치",
        "type": "유형"
      },
      "btnbox": {
        "prev": "이전 ",
        "next": "다음",
        "complete": "완성",
        "cancel": "취소 "
      }
    },
    "fullName": "전체 이름/ 성",
    "lastName": "이름",
    "reportTo": "상급자 (누구에게 보고)",
    "isAssistant": "조수",
    "none": "무"
  }
}
</i18n>
